import axios from 'axios';
import requset from './request';

const service = {
  unauth: {
    login(data: {username:string, pwd:string}) {
      return requset({
        url: '/unauth/login',
        method: 'post',
        data
      })
    },
    logout() {
      return requset({
        url: '/unauth/logout',
        method: 'post'
      })
    },
    infoCfgDetail() {
      return requset({
        url: '/unauth//infoCfg/detail/xnyey',
        method: 'get'
      })
    }
  },
  base: {
    catalogList(data={}){
      return requset({
        url: '/base/catalog/list',
        method: 'post',
        data
      })
    }
  },
  banner: {
    find(data={}){
      return requset({
        url: '/banner/find',
        method: 'post',
        data
      })
    }
  },
  member: {
    currentInfo(data:{}) {
      return requset({
        url: '/member/currentInfo',
        method: 'post',
        data
      })
    },
    updInfo(data: {}) {
      return requset({
        url: '/member/updInfo',
        method: 'post',
        data
      })
    }
  },
  file: {
    getUploadFormData(data: {bucketId:number, fileName: string}){
      return requset({
        url: '/file/getUploadFormData',
        method: 'post',
        data
      })
    },
    saveStorage(data:{}){
      return requset({
        url: '/file/saveStorage',
        method: 'post',
        data
      })
    },
    detail(code:string){
      return requset({
        url: '/file/detail/'+code,
        method: 'get'
      })
    }
  },
  course: {
    find(data: {type?:number, name?:string, courseIdList?: Array<number>, currentPage?: number, pageSize?: number, status?:number}){
      data.status = 1
      return requset({
        url: '/course/find',
        method: 'post',
        data
      })
    },
    detail(courseId:number){
      return requset({
        url: '/course/detail/'+courseId,
        method: 'get'
      })
    },
    chapterDetail(chapterId:number){
      return requset({
        url: '/course/chapter/detail/'+chapterId,
        method: 'get'
      })
    },
    chapterViewLog(chapterId:number){
      return requset({
        url: '/course/chapter/viewLog/'+chapterId,
        method: 'get'
      })
    }
  },
  res: {
    find(data:any){
      return requset({
        url: '/res/find',
        method: 'post',
        data
      })
    },
    detailAndRelName(data:{}){
      return requset({
        url: `/res/detailAndRelName`,
        method: 'post',
        data
      })
    },
    oplog(resId:number, opType:number){
      return requset({
        url: `/res/oplog/${resId}/${opType}`,
        method: 'get'
      })
    }
  },
  kinder: {
    list(data={}){
      return requset({
        url: '/kinder/list',
        method: 'post',
        data
      })
    },
    staffList(data={}){
      return requset({
        url: '/kinder/staffList',
        method: 'post',
        data
      })
    },
    staffDetail(staffId:number){
      return requset({
        url: '/kinder/staffDetail/'+staffId,
        method: 'get'
      })
    },
    jobTitleList(data={}){
      return requset({
        url: '/kinder/jobTitleList',
        method: 'post',
        data
      })
    },
  },
  train: {
    list(data={}){
      return requset({
        url: '/train/list',
        method: 'post',
        data
      })
    }
  },
  info: {
    activityList(data:any={type:1}){
      data['type'] = 1
      return requset({
        url: '/info/list',
        method: 'post',
        data
      })
    },
    detail(infoId:number){
      return requset({
        url: '/info/detail/'+infoId,
        method: 'get'
      })
    }
  },
  organization:{
    findClazz(){
      return requset({
        url: '/organization/findClazz',
        method: 'post',
      })
    }
  },
  cfRecord: {
    listReport(data:{}){
      return requset({
        url: '/cfRecord/listReport',
        method: 'post',
        data
      })
    },
    exportReport(data:{}){
      return requset({
        url: '/cfRecord/exportReport',
        method: 'post',
        responseType:'blob',
        data
      })
    },
    dowloadReport(data:{}){
      return requset({
        url: '/cfRecord/dowloadReport',
        method: 'post',
        responseType:'blob',
        data
      })
    },
    updComment(data:{}){
      return requset({
        url: '/cfRecord/updComment',
        method: 'post',
        data
      })
    },
    findStatistics(data:{}){
      return requset({
        url: '/cfRecord/findStatistics',
        method: 'post',
        data
      })
    },
  }
}

// 上传文件
const upFileUtil = (bucketId:number, fileName: string, file: File, saveStorage?:boolean)=>{
  // 1.请求访问地址
  return service.file.getUploadFormData({bucketId, fileName}).then(result=>{
    const {data} = result
    // 2.上传文件
    const {formData, objectName, contentType, uploadUrl} = data

    let param = new FormData()
    for(let i in formData){
      param.append(i, formData[i])
    }
    param.append('key', objectName)
    param.append('Content-Type', contentType)
    param.append('file', file)

    return axios({
      method: 'post',
      url: uploadUrl,
      data: param,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response)=>{
      console.log(response)
      // 返回http状态204 No Content 标识成功
      // 3.是否需要保存到数据库中
      if(saveStorage){
        return service.file.saveStorage(data)
      }else{
        return data
      }
    })
  })
}
// 存储桶
const BUCKET_ID = {
  IMG: 1,
  VIDEO: 2,
  AUDIO: 3,
  FILE: 4,
  OTHER: 99,
  AVATOR: 101
}
// 资源关联类型
const RES_REL_TYPE = {
  Chapter: "xq.jy.course.entity.CourseChapter",
  KinderStaff: "xq.jy.base.entity.KinderStaff",
  Catalog: "xq.jy.base.entity.Catalog",
  Info: "xq.jy.base.entity.Info"
}
// 操作类型
const OP_TYPE_ENU = {
  ADD: 1,
  EDIT: 2,
  DEL: 3,
  CANCEL: 4,
  AUDIT: 5,
  VIEW: 6,
  DOWNLOAD: 7
}
// 目录类型
const CATALOG_TYPE = {
  RES: 1,
  LIVE: 2,
  GAME: 3,
  TEA: 4,
  SPEC: 5
}

export { upFileUtil, BUCKET_ID, RES_REL_TYPE, OP_TYPE_ENU, CATALOG_TYPE }

export default service